import { createRouter, createWebHistory } from "vue-router";
import globalRoutes from "@/router/global";
import authRoutes from "@/router/auth";
import dashboardRoutes from "@/router/dashboard";

const routes = [authRoutes, dashboardRoutes, globalRoutes];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

const middlewareFactory = (context, middlewares, index) => {
  const nextMiddleware = middlewares[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return () => {
    const nextMiddlewareFn = middlewareFactory(context, middlewares, index + 1);

    nextMiddleware({
      ...context,
      next: nextMiddlewareFn,
    });
  };
};

router.beforeEach((to, from, next) => {
  if (to.meta.middlewares) {
    const middlewares = to.meta.middlewares;

    const nextMiddleware = middlewareFactory(
      { from, next, router, to },
      middlewares,
      0,
    );

    return nextMiddleware();
  }

  return next();
});

export default router;
